(function () {
  'use strict';

  if (customElements.get('sibling-swatches')) return;

  customElements.define('sibling-swatches', class extends HTMLElement {
    constructor() {
      super();
      this.productBlock = this.closest('[data-product-block]') || document;
      this.mainImage = this.productBlock.querySelector('[data-main-image] img');
      this.productLinks = this.productBlock.querySelectorAll('[data-grid-link], .product__media__holder');
      this.siblingSwatches = this.querySelectorAll('a[data-sibling-swatch]');

      this.originalProductUrl = this.getAttribute('data-product-url') || window.location.pathname;
      this.originalSrcset = this.mainImage?.getAttribute('srcset') || '';
      this.originalSrc = this.mainImage?.getAttribute('src') || '';
    }

    connectedCallback() {
      this.siblingSwatches.forEach(a => {
        a.addEventListener('mouseenter', () => this.preview(a));
        a.addEventListener('focus', () => this.preview(a));

        a.addEventListener('click', (e) => {
          const url = a.getAttribute('data-sibling-url') || a.getAttribute('href');
          if (url) {
            e.preventDefault();
            e.stopPropagation();
            window.location.assign(url);
          }
        });

        a.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const url = a.getAttribute('data-sibling-url') || a.getAttribute('href');
            if (url) window.location.assign(url);
          }
        });
      });

      this.addEventListener('mouseleave', () => this.reset());
      this.addEventListener('focusout', () => this.reset());
    }

    preview(a) {
      const imgUrl = a.getAttribute('data-sibling-featured-image-url');
      const prodUrl = a.getAttribute('data-sibling-url') || a.getAttribute('href');

      if (imgUrl && this.mainImage) {
        this.mainImage.setAttribute('srcset', imgUrl);
        this.mainImage.setAttribute('src', imgUrl);
      }
      if (prodUrl && this.productLinks?.length) {
        this.productLinks.forEach(link => link.setAttribute('href', prodUrl));
      }
    }

    reset() {
      this.productLinks?.forEach(link => link.setAttribute('href', this.originalProductUrl));
      if (this.mainImage) {
        if (this.originalSrcset) this.mainImage.setAttribute('srcset', this.originalSrcset);
        if (this.originalSrc) this.mainImage.setAttribute('src', this.originalSrc);
      }
    }
  });
})();
